import React, { createElement } from "react";
import { render } from "react-dom";
import isPropValid from "@emotion/is-prop-valid";
import getTheme from "@grnhse/seedling/lib/birch/themes";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import { createTheme } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PageDataStore from "./page_data_store";

const queryClient = new QueryClient();

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName, target) {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

let ReactMounter = function (componentsByName = {}, options = {}) {
  this.componentsByName = componentsByName;
};

ReactMounter.prototype.init = function () {
  PageDataStore.data.then((data) => {
    window.greenhouseOnboarding = window.greenhouseOnboarding || {};
    window.greenhouseOnboarding.departmentFieldName =
      data.department_field_name;
    window.greenhouseOnboarding.locationFieldName = data.location_field_name;
    window.greenhouseOnboarding.employmentStatusFieldName =
      data.employment_status_field_name;
    window.greenhouseOnboarding.bulkActionPollerPath =
      data.bulk_action_poller_path;
    window.greenhouseOnboarding.bulkExportPollerPath =
      data.bulk_export_poller_path;
    window.greenhouseOnboarding.currentEmployeeId = data.current_employee_id;

    // filter all nodes on page so that we're only mounting the components provided via componentsByName
    const nodes = Array.from(document.querySelectorAll("[data-react-class]"))
      .filter((elem) => this.componentsByName.hasOwnProperty(elem.getAttribute("data-react-class")));

    nodes.forEach((elem) => {
      const className = elem.getAttribute("data-react-class");
      const Component = this.componentsByName[className];

      if (!Component) {
        return;
      }

      const props = data[className];
      const element = createElement(Component, props);

      const seedlingTheme = getTheme("birch");
      const materialUITheme = createTheme();
      const themedComponent = (
        <QueryClientProvider client={queryClient}>
          <StyleSheetManager shouldForwardProp={shouldForwardProp}>
            <ThemeProvider theme={{ ...materialUITheme, ...seedlingTheme }}>
              {element}
            </ThemeProvider>
          </StyleSheetManager>
        </QueryClientProvider>
      );

      render(themedComponent, elem);
    });
  });
};

export default ReactMounter;
